import React from 'react';

const ArrowRight = ({ ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M31.916 15.53l-.021-.022c-.014-.015-.021-.037-.021-.066a.511.511 0 01-.084-.131.281.281 0 00-.126-.132L15.432.286c-.224-.204-.49-.3-.799-.285a.884.884 0 00-.714.373 1.137 1.137 0 00-.274.81c.014.307.133.562.358.767l14.086 12.922H1.093c-.308 0-.567.11-.778.328-.21.22-.315.475-.315.767 0 .321.105.591.315.81.21.22.47.329.778.329H28.09L14.003 30.029a.817.817 0 00-.253.328c-.056.132-.098.27-.126.416 0 .176.021.329.063.46.042.132.12.256.232.373a.986.986 0 00.799.394c.112 0 .23-.03.357-.088.126-.058.245-.131.357-.219L31.664 16.8a.281.281 0 00.126-.131l.084-.175.042-.044c.028-.088.049-.168.063-.241a1.28 1.28 0 00.021-.241c0-.059-.007-.124-.021-.197a2.092 2.092 0 00-.063-.241z"
      ></path>
    </svg>
  );
};

export default ArrowRight;
